import React from "react";
import { Helmet } from "react-helmet";
const DigimarketingHelmet = ({ title }) => {
  return (
    <Helmet>
      <title>
        Top Digital Marketing Agency in USA
      </title>
      <meta
        name="description"
        content="Partner with a leading digital marketing agency in USA. Get expert SEO, PPC, SMM, email, and content marketing to drive traffic, leads, and growth."
      />
    </Helmet>
  );
};

export default DigimarketingHelmet;
